<template>
  <div class="container-fluid" style="background: #F0F0F0;">
    <div class="row" style="">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()"> <i class="fas fa-chevron-left"></i></a>
        </div>
        <div class="category-title">
          <p class="pt-3" style="font-weight: bold"> {{ $t('FRIENDS') }} </p>
        </div>
        <router-link class="search-friend-icon" to="/find-friends">
          <i class="fa fa-search"></i>
        </router-link>
      </div>
    </div>

    <div class="row mt-4">
      <div class="friends d-flex col-lg-12 gap-2  justify-content-between">
        <div class="col-sm-4  leader-box  d-flex justify-content-center align-items-center"
             :class="{'leader-box-active': selectedType === index}"
             v-for="(type, index) in friendTypes" :key="index">
          <span @click="typeChange(index)"> {{ type }}</span>
          <div class="request-count" v-if="pending && index === 'incoming_requests'"> {{ pending }}</div>
        </div>
      </div>
    </div>

    <div class="row" v-if="! noListFound">
      <div class="col-lg-12" v-for="friend in friendList" :key="friend.user_id">
        <div class="friend-user-list d-flex justify-content-between align-items-center">
          <div class="user-details d-flex align-items-center">
            <img :src="friend.image_url" :alt="friend.name">
            <div class="user-name">{{ friend.name }}</div>
          </div>
          <div class="user-action" v-if="selectedType === 'friends'">
            <img src="@/assets/img/challenge.png" alt="challenge">
          </div>
          <div class="user-action-accept d-flex gap-2 justify-content-center align-items-center" v-if="selectedType === 'incoming_requests'">
            <div class="user-action-design d-flex justify-content-center align-items-center" >

              <img src="@/assets/img/happy_img/check.png" alt="accept" @click="requestAccept(friend.user_id)">

            </div>
            <div class="user-action-design d-flex justify-content-center align-items-center">
              <img src="@/assets/img/happy_img/close.png" alt="remove" @click="requestDeny(friend.user_id)">
            </div>

          </div>
          <div class="user-action-cancel" v-if="selectedType === 'outgoing_requests'"
               @click="outgoingRequestDelete(friend.user_id)">
            x
          </div>
        </div>
      </div>

    </div>

    <div class="row mt-4" v-else>
      <div class="friend-details d-flex justify-content-center align-items-center flex-column">
        <div class="no-friend-img">
          <img :src="image" alt="" height="250" width="150">
        </div>
        <div class="no-friend-title mt-3">
          <span>{{ noFriendTitle }}</span>
        </div>
        <div class="no-friend-sub-title">
          {{ $t('YOU_CAN_ADD_FRIEND') }}
        </div>
        <div class="no-friend-btn  d-flex justify-content-center align-items-center mt-3 mb-5">
          {{ $t('SEARCH_FRIEND') }}
        </div>
      </div>
    </div>
    <DashboardFooterMenu/>
  </div>
</template>

<script>
import photo1 from '@/assets/img/no_friends.png';
import photo2 from '@/assets/img/no_friend_request.png';
import photo3 from '@/assets/img/no_sent_request.png';
import DashboardFooterMenu from "@/views/components/DashboardFooterMenu";
import {sendRequest} from "@/http/axios.method";
import _ from "lodash";

export default {
  name: "Friends",
  components: {
    DashboardFooterMenu
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      friendTypes: {
        'friends': this.$t('FRIENDS'),
        'incoming_requests': this.$t('REQUEST'),
        'outgoing_requests': this.$t('SENT_REQUEST')
      },
      selectedType: '',
      image: photo1,
      noFriendTitle: this.$t('YOU_HAVE_NO_FRIENDS'),
      friendList: [],
      noListFound: true,
      pending: 0,
    }
  },
  created() {
    this.selectedType = Object.keys(this.friendTypes)[0];
    this.getFriendList();
  },
  methods: {
    typeChange(type) {
      this.selectedType = type;
      this.getFriendList();
    },
    getFriendList() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/friends', {type: this.selectedType}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.friendList = response.data.friend_list;
              this.pending = response.data.pending;
              this.noListFound = _.isEmpty(this.friendList);
              if (this.noListFound) {
                if (this.selectedType === 'friends') {
                  this.image = photo1;
                  this.noFriendTitle = this.$t('YOU_HAVE_NO_FRIENDS');
                }
                if (this.selectedType === 'incoming_requests') {
                  this.image = photo2;
                  this.noFriendTitle = this.$t('Empty Request');
                }
                if (this.selectedType === 'outgoing_requests') {
                  this.image = photo3;
                  this.noFriendTitle = this.$t('Empty Request');
                }
              }
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    requestAccept(user_id) {
      sendRequest('post', 'v2.0/friend-request-accept', {user_id: user_id}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.getFriendList();
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    requestDeny(user_id) {
      sendRequest('post', 'v2.0/friend-request-deny', {user_id: user_id}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.getFriendList();
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    outgoingRequestDelete(user_id) {
      sendRequest('post', 'v2.0/outgoing-request-delete', {user_id: user_id}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.getFriendList();
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },

  }
}

</script>

<style scoped>

</style>

